var React = require('react');

function Repartitionautomatique (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#35D5C9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"st0","points":"81.2,23.8 30.2,38.5 16.6,27.8 67.6,13.1 \t","key":0}),React.createElement("polygon",{"className":"st0","points":"82.3,48 31.3,62.7 17.7,52 68.7,37.3 \t","key":1}),React.createElement("polygon",{"className":"st0","points":"83.4,72.2 32.4,86.9 18.8,76.2 69.8,61.5 \t","key":2})])]);
}

Repartitionautomatique.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 100 100","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = Repartitionautomatique;

Repartitionautomatique.default = Repartitionautomatique;
